import {ApiClientService, EntityApiService} from '@dofleini/security';

class LabDataIssueEvidenceApiService extends EntityApiService {
  getData = async () => {
    return await ApiClientService.get(this.getPath('')).then((response) => {
      return Promise.resolve({ ...response, data: response?.data });
    });
  };
}

export default (issueId) => new LabDataIssueEvidenceApiService(`/ms-lab/api/issues/${issueId}/evidences`);
